import config from "config/config";
import { CheckCompensationButton, NavButton, LogInButton } from "modules/common/components/HeaderNav";
import { VIEW_CLAIM_STATUS_EVENT_UA, VIEW_CLAIM_STATUS_EVENT } from "modules/common/trackingConsts";
import { useTranslations } from "contexts/LocalizationContext";
import type { ActionButtonProps } from "./ActionButton.d";

const ActionButton = ({ activeButtonOption }: ActionButtonProps) => {
  const translations = useTranslations();

  return {
    "view-claim-status": (
      <NavButton
        href={`${config.webappUrl}/claims-and-flights`}
        title={translations("view_claim_status")}
        gaEvent={VIEW_CLAIM_STATUS_EVENT}
        uaEvent={VIEW_CLAIM_STATUS_EVENT_UA}
        dataTestId="top-navbar-view-status-button"
      />
    ),
    "check-compensation": <CheckCompensationButton />,
    "button-login": <LogInButton />,
  }[activeButtonOption];
};

export default ActionButton;
